import { supabaseClient } from "supabase";

type Organizer = {
  id: number;
  uid: string;
  name: string;
  email: string;
  users?: { id: string }[] | null;
};

export type QueryOrganizersParams = {
  name?: string;
  page?: number;
  perPage?: number;
  activeOnly?: boolean;
};

export const queryOrganizers = async ({
  name,
  page,
  perPage,
  activeOnly,
}: QueryOrganizersParams) => {
  // Use left join by default, switch to inner join when activeOnly is true
  const joinType = activeOnly ? "!inner" : "!left";

  const query = `
    id,
    uid,
    name,
    email,
    users:users${joinType} (
      id
    )
  `;

  let baseQuery = supabaseClient.from("organizers").select(query, {
    count: "exact",
  });

  if (name) {
    baseQuery = baseQuery.ilike("name", `%${name}%`);
  }

  baseQuery = baseQuery.order("name");

  if (page && perPage) {
    baseQuery = baseQuery.range(
      (page - 1) * perPage,
      (page - 1) * perPage + perPage - 1
    );
  }

  const { data, count, error } = await baseQuery;
  if (error) {
    throw error;
  }

  // Transform the response to flatten the users array
  const organizers =
    (data as unknown as Organizer[])?.map((organizer) => ({
      id: organizer.id,
      uid: organizer.uid,
      name: organizer.name,
      email: organizer.email,
      hasUser: organizer.users && organizer.users.length > 0,
    })) || [];

  return { organizers, count };
};
